import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import CategoryIndex from "./components/CategoryIndex";
import TopicDirectory from "./components/TopicDirectory";
import KnowledgeMap from "./components/KnowledgeMap";
import About from "./components/About";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  return (
    <main className="relative min-h-screen w-full">
      <Navbar />
      <Hero />
      <Trending />
      <CategoryIndex />
      <TopicDirectory />
      <KnowledgeMap />
      <About />
      <Faq />
      <Footer />
      <BackToTop />
    </main>
  );
}